import { graphql } from "../../generated"

export const GET_INDEX_WELLS = graphql(`
    query GetIndexWells(
        $first: Int
        $windowedRunTimeInterval: TimeIntervalInput!
        $zoneInfo: ZoneInfo
        $filter: WellFilter
    ) {
        wells(first: $first, filter: $filter) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
                startCursor
            }
            totalCount
            edges {
                node {
                    ...WellIdentificationFields
                    isFavorite
                    alert {
                        ...WellAlertFields
                    }
                    controlSetting {
                        ...ControlSettingFields
                    }
                    state {
                        ...WellControlStateFields
                    }
                    equipmentMetrics {
                        latestSpm {
                            ...DataPointFields
                        }
                        dailyRunTime {
                            ...DataFrameFields
                        }
                        windowedRunTime(
                            zoneInfo: $zoneInfo
                            interval: $windowedRunTimeInterval
                        ) {
                            ...DataFrameFields
                        }
                    }
                }
            }
        }
    }
`)
